var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondSquad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9804 21.5V21.4778L17.0137 15.5333C17.1989 15.2593 17.3211 15.0296 17.3804 14.8444C17.447 14.6593 17.4804 14.4852 17.4804 14.3222C17.4804 14.0407 17.41 13.7852 17.2693 13.5556C17.1285 13.3185 16.9396 13.1333 16.7026 13C16.4656 12.8593 16.1989 12.7889 15.9026 12.7889C15.6063 12.7889 15.3396 12.8593 15.1026 13C14.8656 13.1333 14.6767 13.3185 14.5359 13.5556C14.4026 13.7852 14.3359 14.0407 14.3359 14.3222C14.3359 14.5741 14.3915 14.8148 14.5026 15.0444C14.6137 15.2667 14.7804 15.4704 15.0026 15.6556H13.1582C12.9285 15.2185 12.8137 14.7741 12.8137 14.3222C12.8137 13.9074 12.8915 13.5185 13.047 13.1556C13.21 12.7926 13.4322 12.4741 13.7137 12.2C13.9952 11.9259 14.3248 11.7111 14.7026 11.5556C15.0804 11.4 15.4841 11.3222 15.9137 11.3222C16.3359 11.3222 16.7359 11.4 17.1137 11.5556C17.4915 11.7111 17.8248 11.9259 18.1137 12.2C18.4026 12.4667 18.6285 12.7852 18.7915 13.1556C18.9545 13.5185 19.0359 13.9074 19.0359 14.3222C19.0359 14.5444 19.01 14.763 18.9582 14.9778C18.9063 15.1926 18.8248 15.4111 18.7137 15.6333C18.6026 15.8481 18.4582 16.0852 18.2804 16.3444L15.7137 20.0333H19.1915V21.5H12.9804Z",
    fill: "url(#paint0_linear_12734_12437)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2073 18.7092C30.7774 17.4254 31.1705 15.3088 31.0102 13.0393C30.6291 12.9726 29.8596 12.8182 29.4869 12.7802C30.8412 10.7108 30.2533 8.36584 28.8721 6.13281L27.946 6.42024C24.1174 7.55259 22.6721 10.9881 24.5902 14.4785C23.5462 15.6817 23.242 17.5191 23.3685 19.3596C22.5663 20.0753 21.918 21.2566 21.5191 22.4385C20.4307 22.748 19.4065 23.452 18.5032 24.5205C17.5599 24.4616 16.6556 24.7509 16.0224 25.4013C15.3886 24.7502 14.484 24.4616 13.5401 24.5205C12.6368 23.4521 11.6126 22.748 10.5243 22.4385C10.1252 21.2562 9.4774 20.0761 8.67483 19.3597C8.80153 17.5193 8.49686 15.681 7.45314 14.4786C9.37117 10.9879 7.92593 7.55283 4.09714 6.4203C4.0972 6.4203 3.17139 6.13287 3.17139 6.13287C1.78932 8.36631 1.20267 10.7118 2.55641 12.7803C2.18768 12.8176 1.40998 12.9735 1.03309 13.0394C0.872835 15.3099 1.26644 17.4259 2.83603 18.7092C2.34177 18.9358 1.64479 19.4019 1.17018 19.6996C1.88816 21.9199 3.08445 23.7608 5.10619 24.3261C4.91139 24.5376 4.40891 25.169 4.2178 25.4003L4.83008 26.1521C7.30144 29.2716 11.0168 29.3425 13.5401 26.2802H13.9C14.5851 26.2802 15.1424 26.8375 15.1424 27.5227V31.0007H16.9022V27.5227C16.9022 26.8376 17.4596 26.2802 18.1447 26.2802H18.5031C21.0265 29.3425 24.7416 29.2715 27.213 26.1521C27.213 26.1521 27.8255 25.4003 27.8255 25.4003C27.6312 25.1652 27.1347 24.5411 26.9369 24.3261C28.9595 23.7605 30.1552 21.9188 30.8731 19.6995C30.396 19.4003 29.7042 18.9372 29.2073 18.7092ZM4.02616 8.25756C6.36478 9.14747 7.13497 11.0621 6.06409 13.3236C3.78449 12.4821 2.93088 10.5094 4.02616 8.25756ZM2.77514 14.5264C5.25988 14.2313 6.82953 15.5715 6.92832 18.0716C4.54219 18.3685 2.86407 17.0865 2.77514 14.5264ZM3.3422 20.4261C5.45873 19.2408 7.50223 19.8505 8.52073 22.1583C6.41646 23.3266 4.38416 22.767 3.3422 20.4261ZM9.23848 26.7831C8.2936 26.7831 7.35682 26.3069 6.50826 25.4003C8.12818 23.6198 10.2545 23.5197 11.9688 25.4003C11.1201 26.3069 10.1834 26.7831 9.23848 26.7831ZM28.0895 17.3507C27.3382 18.0147 26.1556 18.2011 25.1151 18.0716C25.2138 15.5713 26.7836 14.2315 29.2682 14.5264C29.2114 15.7668 28.8081 16.7372 28.0895 17.3507ZM25.7154 10.2745C26.0681 9.39783 26.8594 8.70647 28.0173 8.25756C29.1125 10.5095 28.2588 12.4822 25.9794 13.3236C25.455 12.1979 25.3628 11.1511 25.7154 10.2745ZM22.8049 26.7831C21.8601 26.7831 20.9233 26.3069 20.0747 25.4003C21.7893 23.5193 23.9155 23.6202 25.5352 25.4003C24.6866 26.3069 23.7498 26.7831 22.8049 26.7831ZM26.5506 22.6036C25.621 22.9392 24.4289 22.6648 23.5228 22.1583C24.5412 19.8502 26.5849 19.241 28.7012 20.4261C28.184 21.5551 27.4466 22.3039 26.5506 22.6036Z",
    fill: "url(#paint1_linear_12734_12437)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2344 9.58104L16.0226 8.79284L18.8107 9.58104L18.9227 6.68581L20.5339 4.27769L17.8149 3.27655L16.0225 1L14.2301 3.2765L11.5112 4.27769L13.1224 6.68581L13.2344 9.58104ZM15.3051 4.75599L16.0225 3.84472L16.74 4.75599L17.8284 5.15675L17.1835 6.12069L17.1387 7.27967L16.0226 6.96415L14.9065 7.27967L14.8617 6.12069L14.2167 5.15675L15.3051 4.75599Z",
    fill: "url(#paint2_linear_12734_12437)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12734_12437",
    x1: 10.775,
    y1: 9.79167,
    x2: 23.6127,
    y2: 20.9738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A96AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EAEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#C2D4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491919,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615,
    stopColor: "#D4DEE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#ABBDC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "#BCCAD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12734_12437",
    x1: 1.75108,
    y1: 6.65089,
    x2: 23.8234,
    y2: 36.2126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A96AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EAEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#C2D4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491919,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615,
    stopColor: "#D4DEE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#ABBDC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "#BCCAD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12734_12437",
    x1: 11.7368,
    y1: 1.17877,
    x2: 19.5881,
    y2: 10.3306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A96AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EAEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#C2D4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491919,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615,
    stopColor: "#D4DEE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#ABBDC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "#BCCAD7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondSquad);
export default __webpack_public_path__ + "static/media/second_squad.5c395fc3401b5a3acb5b485e385b2c61.svg";
export { ForwardRef as ReactComponent };